import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styles from "../../styles/Countdown.module.scss";
import { fetchSale } from "../../actions/sale";

export default function Countdown(props) {
  const dispatch = useDispatch();
  const { prompt, saleTimeRemaining } = props;

  const [days, setDays] = useState(-1);
  const [hours, setHours] = useState(-1);
  const [minutes, setMinutes] = useState(-1);
  const [seconds, setSeconds] = useState(-1);
  // const [nextSaleCycle, setNextSaleCycle] = useState(couponData.futureSales.length > 0 ? couponData.futureSales[0].saleEnd : 0)
  const [salePrompt, setSalePrompt] = useState("");
  let x;

  async function onLoad() {
    if (saleTimeRemaining !== 0) {
      const countDownDate = saleTimeRemaining + new Date().getTime();

      // Update the count down every 1 second
      x = setInterval(function () {
        // Get today's date and time
        const now = new Date().getTime();

        // Find the distance between now and the count down date
        const distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        setDays(Math.floor(distance / (1000 * 60 * 60 * 24)));
        setHours(
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        );
        setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
        setSeconds(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          // clears the previous interval, will set a new one if applicable.
          clearInterval(x);
          dispatch(fetchSale(true));

          //  if(nextSaleCycle !== 0){
          //     onLoad(nextSaleCycle)
          //     setSalePrompt(couponData.futureSales[0].saleAssets.prompt)
          //     checkForSales()
          //  }else{
          //     setShowSaleUI(false)
          //  }
        }
      }, 1000);
    }
  }

  useEffect(() => {
    onLoad();
    return () => clearInterval(x); //eslint-disable-next-line
  }, [saleTimeRemaining]);

  useEffect(() => {
    setSalePrompt(prompt); //eslint-disable-next-line
  }, [prompt]);

  return (
    <>
      <div className={styles.saleText}>{salePrompt}</div>
      <div className={styles.countdownContainer}>
        <div className={styles.timerWrapper}>
          <div className={styles.countdownWrapper}>
            <span className={styles.countdownNumber}>
              {days >= 0 ? days : "-"}
            </span>
            <span className={styles.countdownLabel}>
              {days === 1 ? "Day" : "Days"}
            </span>
          </div>
          <div className={styles.countdownWrapper}>
            <span className={styles.countdownNumber}>
              {hours >= 0 ? hours : "-"}
            </span>
            <span className={styles.countdownLabel}>
              {hours === 1 ? "Hour" : "Hours"}
            </span>
          </div>
          <div className={styles.countdownWrapper}>
            <span className={styles.countdownNumber}>
              {minutes >= 0 ? minutes : "-"}
            </span>
            <span className={styles.countdownLabel}>
              {minutes === 1 ? "Minute" : "Minutes"}
            </span>
          </div>
          <div className={styles.countdownWrapper}>
            <span className={styles.countdownNumber}>
              {seconds >= 0 ? seconds : "-"}
            </span>
            <span className={styles.countdownLabel}>
              {seconds === 1 ? "Second" : "Seconds"}
            </span>
          </div>
        </div>
      </div>
      <a
        href="https://www.buildbox.com/sale-terms-of-service/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.saleTerms}
      >
        Terms of service
      </a>
    </>
  );
}
